import { Component, type ReactNode } from "react";
import { Link } from "react-router-dom";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export default class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error) {
    console.error("ErrorBoundary caught:", error);
  }

  render() {
    if (this.state.hasError) {
      return (
        <main className="py-20 px-5 text-center">
          <div className="max-w-md mx-auto">
            <div className="text-6xl mb-4">⚠️</div>
            <h1 className="text-2xl font-bold text-zinc-950 dark:text-zinc-100 mb-3">
              문제가 발생했습니다
            </h1>
            <p className="text-zinc-500 dark:text-zinc-400 mb-2">
              예상치 못한 오류가 발생했습니다.
            </p>
            <p className="text-xs text-zinc-400 mb-8 font-mono">
              {this.state.error?.message}
            </p>
            <div className="flex gap-3 justify-center">
              <button
                onClick={() => { this.setState({ hasError: false, error: null }); window.location.reload(); }}
                className="px-6 py-3 bg-indigo-500 text-white text-sm font-semibold rounded-xl hover:bg-indigo-600 transition-colors cursor-pointer"
              >
                새로고침
              </button>
              <Link
                to="/"
                className="px-6 py-3 bg-zinc-100 dark:bg-zinc-800 text-zinc-700 dark:text-zinc-300 text-sm font-semibold rounded-xl hover:bg-zinc-200 dark:hover:bg-zinc-700 transition-colors no-underline"
                onClick={() => this.setState({ hasError: false, error: null })}
              >
                홈으로
              </Link>
            </div>
          </div>
        </main>
      );
    }
    return this.props.children;
  }
}
